import styled from 'styled-components'
import media from '../../../styles/tools/media'
import rem from '../../../styles/tools/rem'
import bgModalDesligamento from '../../../static/bg-modal-desligamento.png'

export const Overlay = styled.div`
  position: fixed;
  z-index: 2000;
  bottom: 0;
  top: 0%;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  height: 100%;
  width: 100%;
`

export const Alert = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  width: 100%;
  z-index: 2001;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`

export const Modal = styled.div`
  z-index: 2002;
  padding: 45px 64px;
  width: 1000px;
  max-width: 90%;
  background-color: #25d6e9;
  background-image: url(${bgModalDesligamento});
  background-repeat: no-repeat;
  background-position: center right;
  background-size: contain;
  color: #230c87;
  ${media.small`
        padding: 15px 24px;
    `};

  h1 {
    font-size: ${rem('48px')};
    font-family: Galano;
    font-weight: 700;
    margin: 0 0 43px 0;
    ${media.small`
        max-width: 100%;
        font-size:${rem('40px')};
    `};
  }
  p {
    font-size: ${rem('26x')};
    font-weight: 400;
    font-family: 'Open Sans', sans-serif;
    max-width: 60%;
    margin: 0 0 24px 0;
    ${media.small`
        max-width: 100%;
        font-size:${rem('18px')};
    `};
  }
  button {
    border: none;
  }

  animation: slide-up 0.3s ease-in-out;
  @keyframes slide-up {
    from {
      transform: translateY(20%);
      opacity: 0;
    }
    to {
      transform: none;
      opacity: 1;
    }
  }
`
export const ModalButton = styled.a`
      display:inline-block;
      color:#fff;
      text-align:center;
      text-decoration:none;
      background:#230C87;
      border-radius:50px;
      padding:18.5px 29.5px;
      font-size:${rem('14px')}
      font-weight: 700;
      font-family:'Open Sans', sans-serif;
      margin:18px 0 37px 0;
`
export const ModalHeader = styled.div`
  display: flex;
  justify-content: flex-end;
  img {
    cursor: pointer;
  }
`



// WEBPACK FOOTER //
// ./src/app/elements/ModalDesligamento/styles.js